export enum AnalysisType {
    'CustomerPackage',
    'FullSubgroup',
    'SubgroupWithTest',
    'SubgroupWithPackage',
    'FreeQLPackage',
    'FreeQLTest',
    'SalesCatalogueTest',
    'SalesCataloguePackage',
    'SalesCatalogueTestBundle',
    'MonographTest',
    'MonographPackage'
}
